import { ContentItem } from '../../../interfaces/ContentItem';

function equalsIgnoreCase(text: string, other: string): boolean {
  return text.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
}

export function getContentFieldValue(content: ContentItem, fieldName: string): string {
  if (!content || !fieldName) return '';

  const fields = content.Fields;
  if (!fields) return '';

  const fieldsFiltered = fields.filter((x) => equalsIgnoreCase(fieldName, x.Name));
  if (fieldsFiltered.length > 0) return fieldsFiltered[0].Value;
  return '';
}
